import type { KioskSessionView } from '@print-saas/shared';
import { AlertIcon } from '../components/icons';
import { MessageScreen } from '../components/MessageScreen';
import { shortId } from '../lib/format';

export function FailedScreen({ session }: { session: KioskSessionView }) {
  return (
    <MessageScreen
      tone="bad"
      icon={<AlertIcon />}
      title="Printing problem — please contact staff"
      subtitle="Your payment is safe. Show this reference to the staff so they can help or refund you."
    >
      <div className="mt-[1vmin] rounded-[2.4vmin] bg-panel px-[6vmin] py-[2.4vmin] ring-2 ring-bad/50">
        <div className="text-[2.2vmin] font-semibold tracking-widest text-muted uppercase">Reference</div>
        <div className="font-mono text-[8vmin] leading-none font-black tracking-[0.15em]">
          {shortId(session.id)}
        </div>
      </div>
    </MessageScreen>
  );
}
